import styled from '@emotion/styled';
import Cross from '../../../../components/Icon/e-remove-outline-12.svg';

export default styled(Cross)({
    alignSelf: 'center',
    gridArea: 'icon'
});
